<template>
  <svg
    v-show="active"
    id="euhFS2GOHcM1"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g transform="translate(-.5-.5)">
      <path
        id="euhFS2GOHcM3"
        clip-rule="evenodd"
        d="M10,27c-1.10457,0-2-.8954-2-2L8,8c0-1.10457.89543-2,2-2h.914c.1944.55614.7192.95459,1.336.95459s1.1416-.39845,1.3361-.95459h1.5778c.1945.55614.7192.95459,1.3361.95459s1.1416-.39845,1.336-.95459h1.5779c.1945.55614.7193.95459,1.3361.95459s1.1416-.39845,1.3361-.95459L23,6c1.1046,0,2,.89543,2,2v17c0,1.1046-.8954,2-2,2h-.9139c-.1945-.5561-.7192-.9546-1.3361-.9546s-1.1416.3985-1.336.9546h-1.5947c-.2067-.5322-.7195-.909-1.3193-.909-.5999,0-1.1127.3768-1.3193.909h-1.5946c-.1945-.5561-.7192-.9546-1.3361-.9546s-1.1416.3985-1.336.9546L10,27Z"
        fill="#000860"
        fill-rule="evenodd"
        opacity="0"
      />
      <g id="euhFS2GOHcM4" mask="url(#euhFS2GOHcM6)">
        <path
          d="M8,25h2-2ZM8,8h-2h2Zm2.914-2l1.8879-.66015C12.5213,4.53739,11.7641,4,10.914,4v2Zm2.6721,0v-2c-.8501,0-1.6073.53739-1.8879,1.33985L13.5861,6Zm1.5778,0l1.8879-.66015C16.7712,4.53739,16.014,4,15.1639,4v2ZM17.836,6v-2c-.8501,0-1.6073.53739-1.8879,1.33985L17.836,6Zm1.5779,0l1.888-.66015C21.0213,4.53739,20.2641,4,19.4139,4v2Zm2.6722,0v-2c-.8501,0-1.6073.53739-1.8879,1.33985L22.0861,6ZM25,8h-2h2Zm0,17h2-2Zm-2.9139,2l-1.8879.6602C20.4788,28.4626,21.236,29,22.0861,29v-2ZM19.414,27v2c.8501,0,1.6073-.5374,1.8879-1.3398L19.414,27Zm-1.5947,0l-1.8645.7238C16.2535,28.4931,16.994,29,17.8193,29v-2Zm-2.6386,0v2c.8253,0,1.5658-.5069,1.8644-1.2762L15.1807,27Zm-1.5946,0l-1.8879.6602C11.9788,28.4626,12.736,29,13.5861,29v-2ZM10.914,27v2c.85,0,1.6073-.5374,1.8879-1.3398L10.914,27ZM6,25c0,2.2091,1.79086,4,4,4v-4v0h-4ZM6,8v17h4v-17h-4Zm4-4C7.79086,4,6,5.79086,6,8h4v-4Zm.914,0L10,4v4h.914v-4Zm1.336.95459c.2706,0,.4782.17468.5519.38526L9.02606,6.66015C9.48862,7.983,10.7458,8.95459,12.25,8.95459v-4Zm-.5518.38526c.0736-.21058.2813-.38526.5518-.38526v4c1.5042,0,2.7615-.97159,3.224-2.29444l-3.7758-1.3203ZM15.1639,4h-1.5778v4h1.5778v-4ZM16.5,4.95459c.2705,0,.4782.17468.5518.38526L13.276,6.66015C13.7385,7.983,14.9958,8.95459,16.5,8.95459v-4Zm-.5519.38526c.0737-.21058.2813-.38526.5519-.38526v4c1.5042,0,2.7614-.97159,3.2239-2.29444l-3.7758-1.3203ZM19.4139,4h-1.5779v4h1.5779v-4Zm1.3361.95459c.2705,0,.4782.17468.5519.38526L17.526,6.66015c.4626,1.32285,1.7198,2.29444,3.224,2.29444v-4Zm-.5518.38526c.0736-.21058.2813-.38526.5518-.38526v4c1.5042,0,2.7614-.97159,3.224-2.29444l-3.7758-1.3203ZM23,4h-.9139v4L23,8v-4Zm4,4c0-2.20914-1.7909-4-4-4v4v0h4Zm0,17v-17h-4v17h4Zm-4,4c2.2091,0,4-1.7909,4-4h-4v0v4Zm-.9139,0L23,29v-4h-.9139v4ZM20.75,28.0454c-.2705,0-.4782-.1747-.5518-.3852l3.7758-1.3204c-.4626-1.3228-1.7198-2.2944-3.224-2.2944v4Zm.5519-.3852c-.0737.2105-.2814.3852-.5519.3852v-4c-1.5042,0-2.7614.9716-3.224,2.2944l3.7759,1.3204ZM17.8193,29h1.5947v-4h-1.5947v4ZM16.5,28.091c-.263,0-.467-.1658-.5452-.3672l3.7289-1.4476c-.4914-1.2659-1.721-2.1852-3.1837-2.1852v4Zm.5451-.3672c-.0782.2014-.2821.3672-.5451.3672v-4c-1.4627,0-2.6923.9193-3.1837,2.1852l3.7288,1.4476ZM13.5861,29h1.5946v-4h-1.5946v4ZM12.25,28.0454c-.2705,0-.4782-.1747-.5518-.3852l3.7758-1.3204c-.4626-1.3228-1.7198-2.2944-3.224-2.2944v4Zm.5519-.3852c-.0737.2105-.2814.3852-.5519.3852v-4c-1.5042,0-2.76138.9716-3.22395,2.2944l3.77585,1.3204ZM10,29h.914v-4L10,25v4Z"
          fill="#016dbf"
        />
        <mask
          id="euhFS2GOHcM6"
          height="400%"
          mask-type="luminance"
          width="400%"
          x="-150%"
          y="-150%"
        >
          <path
            clip-rule="evenodd"
            d="M10,27c-1.10457,0-2-.8954-2-2L8,8c0-1.10457.89543-2,2-2h.914c.1944.55614.7192.95459,1.336.95459s1.1416-.39845,1.3361-.95459h1.5778c.1945.55614.7192.95459,1.3361.95459s1.1416-.39845,1.336-.95459h1.5779c.1945.55614.7193.95459,1.3361.95459s1.1416-.39845,1.3361-.95459L23,6c1.1046,0,2,.89543,2,2v17c0,1.1046-.8954,2-2,2h-.9139c-.1945-.5561-.7192-.9546-1.3361-.9546s-1.1416.3985-1.336.9546h-1.5947c-.2067-.5322-.7195-.909-1.3193-.909-.5999,0-1.1127.3768-1.3193.909h-1.5946c-.1945-.5561-.7192-.9546-1.3361-.9546s-1.1416.3985-1.336.9546L10,27Z"
            fill="#fff"
            fill-rule="evenodd"
          />
        </mask>
      </g>
      <g id="euhFS2GOHcM8" opacity="0">
        <g id="euhFS2GOHcM9_to" transform="translate(16.5,16.499945)">
          <g transform="translate(-19.33339,-16.499945)">
            <rect
              fill="#fff"
              height="1.90909"
              rx="0.954545"
              ry="0.954545"
              transform="translate(17.4536 12.6816)"
              width="3.77778"
            />
            <rect
              fill="#fff"
              height="1.90909"
              rx="0.954545"
              ry="0.954545"
              transform="translate(17.4354 18.4092)"
              width="3.77778"
            />
          </g>
        </g>
        <g id="euhFS2GOHcM12_to" transform="translate(16.5,16.499945)">
          <g transform="translate(-13.66669,-16.499945)">
            <rect
              fill="#fff"
              height="1.90909"
              rx="0.954545"
              ry="0.954545"
              transform="translate(11.7869 12.6816)"
              width="3.77778"
            />
            <rect
              fill="#fff"
              height="1.90909"
              rx="0.954545"
              ry="0.954545"
              transform="translate(11.7687 18.4092)"
              width="3.77778"
            />
          </g>
        </g>
      </g>
      <g id="euhFS2GOHcM15">
        <g id="euhFS2GOHcM16_to" transform="translate(19.5,16.499945)">
          <g transform="translate(-19.33339,-16.499945)">
            <rect
              fill="#016dbf"
              height="1.90909"
              rx="0.954545"
              ry="0.954545"
              transform="translate(17.4536 12.6816)"
              width="3.77778"
            />
            <rect
              fill="#016dbf"
              height="1.90909"
              rx="0.954545"
              ry="0.954545"
              transform="translate(17.4354 18.4092)"
              width="3.77778"
            />
          </g>
        </g>
        <g id="euhFS2GOHcM19_to" transform="translate(13.5,16.499945)">
          <g transform="translate(-13.66669,-16.499945)">
            <rect
              fill="#016dbf"
              height="1.90909"
              rx="0.954545"
              ry="0.954545"
              transform="translate(11.7869 12.6816)"
              width="3.77778"
            />
            <rect
              fill="#016dbf"
              height="1.90909"
              rx="0.954545"
              ry="0.954545"
              transform="translate(11.7687 18.4092)"
              width="3.77778"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts" setup>
type Props = {
  active?: boolean
}

defineProps<Props>()
</script>

<style lang="css">
/* stylelint-disable */

#euhFS2GOHcM3 {
  animation: euhFS2GOHcM3_c_o 800ms linear 1 normal forwards;
}
@keyframes euhFS2GOHcM3_c_o {
  0% {
    opacity: 0;
  }

  25% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

#euhFS2GOHcM4 {
  animation: euhFS2GOHcM4_c_o 800ms linear 1 normal forwards;
}
@keyframes euhFS2GOHcM4_c_o {
  0% {
    opacity: 1;
  }

  12.5% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

#euhFS2GOHcM8 {
  animation: euhFS2GOHcM8_c_o 800ms linear 1 normal forwards;
}
@keyframes euhFS2GOHcM8_c_o {
  0% {
    opacity: 0;
  }

  12.5% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  37.5% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

#euhFS2GOHcM9_to {
  animation: euhFS2GOHcM9_to__to 800ms linear 1 normal forwards;
}
@keyframes euhFS2GOHcM9_to__to {
  0% {
    transform: translate(16.5px, 16.499945px);
  }

  25% {
    transform: translate(16.5px, 16.499945px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  58.75% {
    transform: translate(20.757361px, 16.499945px);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }

  83.75% {
    transform: translate(19.5px, 16.499945px);
  }

  100% {
    transform: translate(19.5px, 16.499945px);
  }
}

#euhFS2GOHcM12_to {
  animation: euhFS2GOHcM12_to__to 800ms linear 1 normal forwards;
}
@keyframes euhFS2GOHcM12_to__to {
  0% {
    transform: translate(16.5px, 16.499945px);
  }

  25% {
    transform: translate(16.5px, 16.499945px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  58.75% {
    transform: translate(12.242639px, 16.499945px);
  }

  83.75% {
    transform: translate(13.5px, 16.499945px);
  }

  100% {
    transform: translate(13.5px, 16.499945px);
  }
}

#euhFS2GOHcM15 {
  animation: euhFS2GOHcM15_c_o 800ms linear 1 normal forwards;
}
@keyframes euhFS2GOHcM15_c_o {
  0% {
    opacity: 1;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  12.5% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

#euhFS2GOHcM16_to {
  animation: euhFS2GOHcM16_to__to 800ms linear 1 normal forwards;
}
@keyframes euhFS2GOHcM16_to__to {
  0% {
    transform: translate(19.5px, 16.499945px);
  }

  21.25% {
    transform: translate(19.5px, 16.499945px);
  }

  25% {
    transform: translate(16.5px, 16.499945px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  58.75% {
    transform: translate(20.757361px, 16.499945px);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }

  83.75% {
    transform: translate(19.5px, 16.499945px);
  }

  100% {
    transform: translate(19.5px, 16.499945px);
  }
}

#euhFS2GOHcM19_to {
  animation: euhFS2GOHcM19_to__to 800ms linear 1 normal forwards;
}
@keyframes euhFS2GOHcM19_to__to {
  0% {
    transform: translate(13.5px, 16.499945px);
  }

  21.25% {
    transform: translate(13.5px, 16.499945px);
  }

  25% {
    transform: translate(16.5px, 16.499945px);
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }

  58.75% {
    transform: translate(12.242639px, 16.499945px);
  }

  83.75% {
    transform: translate(13.5px, 16.499945px);
  }

  100% {
    transform: translate(13.5px, 16.499945px);
  }
}
</style>
